/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductDocumentDto } from './ProductDocumentDto';
import {
    ProductDocumentDtoFromJSON,
    ProductDocumentDtoFromJSONTyped,
    ProductDocumentDtoToJSON,
    ProductDocumentDtoToJSONTyped,
} from './ProductDocumentDto';

/**
 * 
 * @export
 * @interface GetProductDocumentResponse
 */
export interface GetProductDocumentResponse {
    /**
     * 
     * @type {Array<ProductDocumentDto>}
     * @memberof GetProductDocumentResponse
     */
    activeDocuments?: Array<ProductDocumentDto>;
    /**
     * 
     * @type {Array<ProductDocumentDto>}
     * @memberof GetProductDocumentResponse
     */
    archivedDocuments?: Array<ProductDocumentDto>;
}

/**
 * Check if a given object implements the GetProductDocumentResponse interface.
 */
export function instanceOfGetProductDocumentResponse(value: object): value is GetProductDocumentResponse {
    return true;
}

export function GetProductDocumentResponseFromJSON(json: any): GetProductDocumentResponse {
    return GetProductDocumentResponseFromJSONTyped(json, false);
}

export function GetProductDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'activeDocuments': json['activeDocuments'] == null ? undefined : ((json['activeDocuments'] as Array<any>).map(ProductDocumentDtoFromJSON)),
        'archivedDocuments': json['archivedDocuments'] == null ? undefined : ((json['archivedDocuments'] as Array<any>).map(ProductDocumentDtoFromJSON)),
    };
}

export function GetProductDocumentResponseToJSON(json: any): GetProductDocumentResponse {
    return GetProductDocumentResponseToJSONTyped(json, false);
}

export function GetProductDocumentResponseToJSONTyped(value?: GetProductDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeDocuments': value['activeDocuments'] == null ? undefined : ((value['activeDocuments'] as Array<any>).map(ProductDocumentDtoToJSON)),
        'archivedDocuments': value['archivedDocuments'] == null ? undefined : ((value['archivedDocuments'] as Array<any>).map(ProductDocumentDtoToJSON)),
    };
}

